import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Progress } from 'antd';
import Label from 'components/form/Label/Label';
import { ReactComponent as ArrowUp } from 'style/_assets/icons/arrow-up.svg';
import { ReactComponent as ArrowDown } from 'style/_assets/icons/arrow-down.svg';
import React from 'react';
import {
  getRatingFontColor,
  getRatingFromScore,
  getScoreGuagePercent,
} from 'helpers/calculations';
import classnames from 'classnames';
import './ScoreDisplay.scss';

const FreeTrialScoreDisplay = props => {
  const {
    scoreChange,
    score,
    onClickItem,
    datatestid,
    showSesamePotential,
    tabletView,
    mobileView,
    hideRating,
    isFreeTrial,
    isSmallDial,
  } = props;
  const rating = getRatingFromScore(score, mobileView);
  const ratingColor = getRatingFontColor(rating);
  let width = 204;
  if (showSesamePotential || tabletView) {
    width = 136;
  } else if (mobileView) {
    width = 120;
  } else {
    width = 136;
  }

  const scorePercentage = getScoreGuagePercent(score);
  const creditRatingClass = classnames('creditRating', {
    'text-8 letterSpacing05': mobileView,
    Overline: !mobileView,
    'text-12': showSesamePotential || tabletView,
  });
  const dashboardScoreClass = classnames(
    'dashboardScore',
    'autoCenter',
    `progress4${ratingColor}`,
    { mobileView: mobileView || '' },

    {
      isFreeTrialWidth: isFreeTrial,
      isSmallDial: isFreeTrial && isSmallDial,
    },
  );

  return (
    <FlexContainer
      className={classnames(
        dashboardScoreClass,
        'dashboardScoreProgress',
        'scoreDisplay',
      )}
    >
      <Progress
        onClick={onClickItem}
        type="dashboard"
        percent={scorePercentage}
        format={() => (
          <>
            <Label
              type="Subtitle-1"
              data-testid={datatestid ? `${datatestid}-scorePotential` : null}
              className={`scoreChangeSection`}
            >
              {scoreChange > 0 && (
                <div className="fontGreen300">
                  <ArrowUp className="up" />
                  {scoreChange}
                </div>
              )}
              {scoreChange < 0 && (
                <div className="fontRed100">
                  <ArrowDown className="down" />
                  {Math.abs(scoreChange)}
                </div>
              )}
            </Label>
            <div className="padB8"></div>
            {score && (
              <Label
                type="text-36 bold fontGray500 m-text-34"
                data-testid={datatestid ? `${datatestid}-score` : null}
              >
                {score === 0 || score === 4 ? props.zeroScoreDisplay : score}
              </Label>
            )}
            {!hideRating && (
              <Label
                type={creditRatingClass}
                color={ratingColor}
                data-testid={
                  datatestid ? `${datatestid}-scoreDescription` : null
                }
                className="scoreRating"
              >
                {hideRating ? <>&nbsp;</> : rating}
              </Label>
            )}
          </>
        )}
        width={width}
      />
    </FlexContainer>
  );
};

FreeTrialScoreDisplay.defaultProps = {
  zeroScoreDisplay: '--',
  hideRating: false,
};

export default FreeTrialScoreDisplay;
